import React, { Component } from 'react';
import Helmet from 'react-helmet';
import Header from './Header';
import Footer from '../../components/Footer/Footer';
import Join from '../../components/JoinModal/JoinModal';
import Modal from '../../components/Modal/Modal';

class TypeSurvey extends Component {
  state = {
    modal: false
  }
  render() {
    const styles = require('./TypeSurvey.less');

    return [
      <Helmet
        key="0"
        htmlAttributes={{ lang: 'ru-RU' }}
        title="Создать анкету для опороса через онлайн сервиса для создания опросов и сбора отзывов (обратной связи) / оценок и аналитики от Клиентов (ЦА) – Mvoter.com"
        meta={[{ name: 'description', content: 'Создание анкеты опросника MVoter – Онлайн платформа для создания моментальной обратной связи с Клиентами! Онлайн сервис по сбору отзывов ✓ Анализ обратной связи от ЦА и потребителей ✓ Управление удовлетворенностью клиентов ✓ Отрасли использования опросника: Рестораны, Банки, Здравоохранение, Торговля, Общественный транспорт ☎ +7 (747) 359-5959' }]}
      />,
      <Header key="1" />,
      <div key="2" className={ styles.content }>
        <div className={ styles.inner }>
          <div className={ styles.wrap }>
            <h1>Создайте анкету на любую тему</h1>
            <p className={ styles.subtitle }>Создайте анкету на любую тему. Получите вдохновение здесь и сейчас!</p>
            <p className={ styles.subtitle }>Или выберите подходящую из более + 100 готовых анкет</p>
            <ul className={ styles.list }>
              <li>
                <h4>Удовлетворенность сервисом</h4>
                <p>Оперативно и объективно отслеживайте качество сервиса предоставляемых вашими работниками. Цените каждого клиента. Достигайте вместе с MVoter лучшего уровня сервиса в вашей отрасли.</p>
              </li>
              <li>
                <h4>Удовлетворенность товаром/продуктом</h4>
                <p>Знайте где в каком регионе, какие социальные группы недовольны вашим продуктом, чем именно недовольны. Постоянно повышайте качество ваших продуктов и товаров вместе с MVoter и завоёвывайте новые рынки.</p>
              </li>
              <li>
                <h4>Удовлетворенность заведением / компанией</h4>
                <p>Отслеживайте репутацию вашего заведения или компании/организации. Не допускайте себе неведения о том что думает о вас ваша Целевая Аудитория. Узнайте свои сильные и слабые стороны лучшим образом, вместе с MVoter.</p>
              </li>
              <li>
                <h4>Net Promoter Score (NPS)</h4>
                <p>NPS это индекс доверия и готовности вашей Целевой Аудитории быть промоутерами вашей продукции и ваших услуг.  Чем выше ваш индекс NPS тем выше вероятность что ваши продажи будут расти. Работайте на опережение вместе с MVoter.</p>
              </li>
              <li>
                <h4>Customer Effort Score (CES)</h4>
                <p>Показатель, который измеряет сколько усилий клиенту пришлось приложить, чтобы решить проблему, выполнить покупку, вернуть продукт или получить ответ на вопрос. Помните что клиенты более лояльны к продукту или услуге, которыми проще пользоваться.</p>
              </li>
              <li>
                <h4>Customer Satisfaction Score (CSAT)</h4>
                <p>Индекс удовлетворенности клиентов – необходимо замерять «здесь и сейчас», поскольку относится к конкретному клиентскому опыту. Когда вы поймете, что именно удовлетворенность ваших клиентов определяет ваши доходы, вы начнете менять свой бизнес к лучшему.</p>
              </li>
            </ul>
            <h3>Создайте систему обратной связи сейчас. Это просто.</h3>
            <ul className={ styles.buttons }>
              <li><span onClick={ () => this.setState({ modal: true }) }>Регистрация</span></li>
              <li><span onClick={ () => this.setState({ modal: true }) }>Запросить демонстрацию</span></li>
            </ul>
          </div>
        </div>
        { this.state.modal
          && (
            <Modal
              title="Запросить демонстрацию"
              content={ <Join onCloseClick={ () => this.setState({ modal: false }) } /> }
              onCloseClick={ () => this.setState({ modal: false }) }
            />
          )}
      </div>,
      <Footer key="3" subId="page" />
    ];
  }
}

export default TypeSurvey;
